import { Saga as ReduxSaga } from 'redux-saga';

export interface SagaProps {
  saga: ReduxSaga;
}

interface SagaInternalProps {
  sagaId: number;
}

export interface SagaComposedProps extends SagaProps, SagaInternalProps {}

type SagaType = <Props>(props: SagaComposedProps & Props) => null;

const Saga: SagaType = () => null;

/**
 * @since 0.21.0
 * @component
 * @visibleName Saga
 */
export default Saga;
